export function joinInfoMeta(target, toAppend) {
  for (let key in toAppend.meta) {
    if (target.meta[key] === undefined) {
      target.meta[key] = toAppend.meta[key];
    }
  }

  for (let key in toAppend.info) {
    if (target.info[key] === undefined) {
      target.info[key] = toAppend.info[key];
    }
  }

  for (let key in target.meta) {
    if (!Array.isArray(target.meta[key])) {
      target.meta[key] = [target.meta[key]];
    }
  }
}
